var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),(_vm.isRouterAlive)?_c('router-view',{key:_vm.reFresh,staticClass:"h-min-vh-50"}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }